import { useState, useEffect } from 'react';
import { MainCard } from '@/components';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '@/utils/auth';
import { PagesPaths } from '@/enums';
import SignUpForm from './components/SignUpForm/SignUpForm';
import SignUpMessage from './components/SignUpMessage/SignUpMessage';

const SignUp = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate(PagesPaths.PrivateHome, { replace: true });
    }
  }, [navigate]);

  const [successfulSignup, setSuccessfulSignup] = useState(false);

  return (
    <MainCard>
      {successfulSignup ? (
        <SignUpMessage />
      ) : (
        <SignUpForm onSignUp={() => setSuccessfulSignup(true)} />
      )}
    </MainCard>
  );
};

export default SignUp;
